import { msg } from '@lingui/core/macro'
import { entityId } from '@pkg/db/schema'
import { defineEnum } from '@pkg/shared/utils/enum-builder'
import dayjs from 'dayjs'
import { z } from 'zod'
import { PatientRelation } from './PatientRelation'

export const MedicalSupplyAccessTypeEnum = defineEnum({
  PORT: { label: msg`Port` },
  PICC_LINE_CATHETER: { label: msg`PICC-Line Katheter` },
  GROSHONG: { label: msg`Groshong` },
  BROVIAC: { label: msg`Broviac` },
  CENTRAL_VENOUS_CATHETER: { label: msg`Zentralvenöser Katheter` },
  PERIPHERAL_VENOUS_CATHETER: { label: msg`Peripherer Venenkatheter` },
  MID_LINE_CATHETER: { label: msg`Midline-Katheter` },
  SUBCUTANEOUS_CATHETER: { label: msg`Subkutaner Katheter` },
  PEG: { label: msg`PEG` },
  PEJ: { label: msg`PEJ` },
  DRAIN_PROBE: { label: msg`Ablaufsonde` },
  NASOGASTRIC_TUBE: { label: msg`transnasale Magensonde` },
})

export type MedicalSupplyAccessType = typeof MedicalSupplyAccessTypeEnum.$.Type

export const PatientMedicalSupplyAccessId = entityId('patientMedicalSupplyAccess')

export type PatientMedicalSupplyAccessIdType = typeof PatientMedicalSupplyAccessId.Type

export const PatientMedicalSupplyAccessRelationSchema = PatientRelation.extend({
  id: PatientMedicalSupplyAccessId.schema,
  access: z.enum(MedicalSupplyAccessTypeEnum.$.zodEnum()),
  activeFrom: z.iso.date().default(() => dayjs().format('YYYY-MM-DD')),
})

export type PatientMedicalSupplyAccessRelation = z.infer<typeof PatientMedicalSupplyAccessRelationSchema>
